// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.We52aavPSart2TuuRU5T {
  /* Override default styling for mystery theme */
  /* Level Currency Font Size */
  --jp-currency-position: relative;
  --jp-currency-line-height: 1;
  --jp-grand-currency-font-size: 14px;
  --jp-major-currency-font-size: 11px;
  --jp-minor-currency-font-size: 6px;
  --jp-mini-currency-font-size: 6px;
  /* Mystery-specific level styling */
  /* Panel icon styling */
}
.We52aavPSart2TuuRU5T div[data-type='levelsContainer'] {
  row-gap: 0;
}
.We52aavPSart2TuuRU5T div[data-level='grand'] {
  --jp-level-padding-top: 22px;
}
.We52aavPSart2TuuRU5T div[data-level='major'] {
  --jp-level-padding-top: 18px;
}
.We52aavPSart2TuuRU5T div[data-level='major'] span[data-currency-level='major'] {
  --jp-currency-margin-left: 8px;
}
.We52aavPSart2TuuRU5T div[data-level='minor'],
.We52aavPSart2TuuRU5T div[data-level='mini'] {
  --jp-level-padding-top: 10px;
  --jp-currency-span-height: 1em;
}
.We52aavPSart2TuuRU5T div[data-level='minor'] span[data-currency-level='minor'],
.We52aavPSart2TuuRU5T div[data-level='mini'] span[data-currency-level='minor'],
.We52aavPSart2TuuRU5T div[data-level='minor'] span[data-currency-level='mini'],
.We52aavPSart2TuuRU5T div[data-level='mini'] span[data-currency-level='mini'] {
  --jp-currency-margin-left: 5px;
}
.We52aavPSart2TuuRU5T div[data-level='mini'] {
  margin-left: -10px;
}
.We52aavPSart2TuuRU5T [data-currency-level] {
  left: 0;
  bottom: 1px;
}
.We52aavPSart2TuuRU5T div[data-type='panelIcon'] {
  max-width: 110px;
}
@media (max-width: 1025px) {
  .We52aavPSart2TuuRU5T {
    /* Level Font Size */
    --jp-grand-font-size: 37px;
    --jp-major-font-size: 32px;
    --jp-minor-font-size: 19px;
    --jp-mini-font-size: 19px;
  }
  .We52aavPSart2TuuRU5T div[data-type='panelIcon'] {
    max-width: 100px;
  }
}
@media (orientation: portrait) {
  .We52aavPSart2TuuRU5T {
    margin-bottom: 17px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/jackpots/components/variants/HighCash/HighCash.module.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;EAC/C,6BAA6B;EAC7B,gCAAgC;EAChC,4BAA4B;EAC5B,mCAAmC;EACnC,mCAAmC;EACnC,kCAAkC;EAClC,iCAAiC;EACjC,mCAAmC;EACnC,uBAAuB;AACzB;AACA;EACE,UAAU;AACZ;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,8BAA8B;AAChC;AACA;;EAEE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;;;;EAIE,8BAA8B;AAChC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,OAAO;EACP,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,oBAAoB;IACpB,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,yBAAyB;EAC3B;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".highCashTheme {\n  /* Override default styling for mystery theme */\n  /* Level Currency Font Size */\n  --jp-currency-position: relative;\n  --jp-currency-line-height: 1;\n  --jp-grand-currency-font-size: 14px;\n  --jp-major-currency-font-size: 11px;\n  --jp-minor-currency-font-size: 6px;\n  --jp-mini-currency-font-size: 6px;\n  /* Mystery-specific level styling */\n  /* Panel icon styling */\n}\n.highCashTheme div[data-type='levelsContainer'] {\n  row-gap: 0;\n}\n.highCashTheme div[data-level='grand'] {\n  --jp-level-padding-top: 22px;\n}\n.highCashTheme div[data-level='major'] {\n  --jp-level-padding-top: 18px;\n}\n.highCashTheme div[data-level='major'] span[data-currency-level='major'] {\n  --jp-currency-margin-left: 8px;\n}\n.highCashTheme div[data-level='minor'],\n.highCashTheme div[data-level='mini'] {\n  --jp-level-padding-top: 10px;\n  --jp-currency-span-height: 1em;\n}\n.highCashTheme div[data-level='minor'] span[data-currency-level='minor'],\n.highCashTheme div[data-level='mini'] span[data-currency-level='minor'],\n.highCashTheme div[data-level='minor'] span[data-currency-level='mini'],\n.highCashTheme div[data-level='mini'] span[data-currency-level='mini'] {\n  --jp-currency-margin-left: 5px;\n}\n.highCashTheme div[data-level='mini'] {\n  margin-left: -10px;\n}\n.highCashTheme [data-currency-level] {\n  left: 0;\n  bottom: 1px;\n}\n.highCashTheme div[data-type='panelIcon'] {\n  max-width: 110px;\n}\n@media (max-width: 1025px) {\n  .highCashTheme {\n    /* Level Font Size */\n    --jp-grand-font-size: 37px;\n    --jp-major-font-size: 32px;\n    --jp-minor-font-size: 19px;\n    --jp-mini-font-size: 19px;\n  }\n  .highCashTheme div[data-type='panelIcon'] {\n    max-width: 100px;\n  }\n}\n@media (orientation: portrait) {\n  .highCashTheme {\n    margin-bottom: 17px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"highCashTheme": `We52aavPSart2TuuRU5T`
};
export default ___CSS_LOADER_EXPORT___;
